import * as actionTypes from '../actions/actionTypes'

const initialState = []

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CATEGORIES:
      return action.categories
    default:
      return state
  }
}

export default reducer
